export const doordashInstacartExtensionId = 'ngkgfnlcibmlkgflcplfibnpeeglbjga';
